import api from 'src/api';
import omit from 'lodash/omit';
import omitBy from 'lodash/omitBy';
import isArray from 'lodash/isArray';
import keyBy from 'lodash/keyBy';
import orderBy from 'lodash/orderBy';

export default {
    namespaced: true,
    state: {
        list: {},
        charts: {},
    },
    mutations: {
        add(state, grosses) {
            if (!isArray(grosses)) {
                grosses = [grosses];
            }

            grosses = grosses.map(gross => ({
                ...state.list[gross.id],
                ...gross,
            }));

            state.list = {
                ...state.list,
                ...keyBy(grosses, 'id'),
            };
        },
        addChart(state, { data, slug }) {
            state.charts = { ...state.charts, [slug]: data };
        },
        clearShow(state, id) {
            state.list = omitBy(state.list, gross => gross.show_id === id);
        },
    },
    getters: {
        forShow: (state, getters, rootState) => id => {
            return orderBy(
                Object.values(state.list)
                    .filter(gross => gross.show_id === id)
                    .map(gross => ({
                        ...gross,
                        week: rootState.week.list[gross.week_id],
                    })),
                rootState.shows.sortCol,
                rootState.shows.sortDirection,
            );
        },
        chartForShow: state => slug => {
            return state.charts[slug] || [];
        },
    },
    actions: {
        add({ commit }, gross) {
            commit('add', gross);
        },
        clearShow({ commit }, id) {
            commit('clearShow', id);
        },
        fetchForShow(
            { commit },
            { slug, sortKey, sortDirection, page, clearShow },
        ) {
            const params = {
                sortKey,
                sortDirection,
                page,
            };

            return api.get(`show/${slug}/grosses`, { params }).then(result => {
                if (clearShow && result.data.data.length) {
                    commit('clearShow', result.data.data[0].show_id);
                }

                commit('week/add', result.data.data.map(gross => gross.week), {
                    root: true,
                });

                commit(
                    'add',
                    result.data.data.map(gross => omit(gross, 'week')),
                );

                commit(
                    'shows/updateSortParams',
                    { sortKey, sortDirection },
                    { root: true },
                );

                commit('shows/updatePage', page, { root: true });

                return result.data;
            });
        },
        fetchChartForShow({ commit, getters }, slug) {
            return api.get(`show/${slug}/chart`).then(result => {
                commit('addChart', { slug, data: result.data.data });

                return result.data;
            });
        },
    },
};
